import ApiClient from "./ApiClient";

export const updateProfile = ({ token, data }) => {
  return ApiClient.post('/api/profiles/update', data, {
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'multipart/form-data',
    }
  });
}